import PropTypes from 'prop-types';
import React from 'react';
import IntlDate from 'src/components/intl-date';
import { getUuid } from 'src/utils/url';

const ToolingStockCustomFields = ({ customFieldValues, customFieldsByUri, emptyMessage }) => {
  const renderValue = (field, customFieldDefinition) => {
    const rawValue = field?.value;
    if (rawValue == null || rawValue === '' || (Array.isArray(rawValue) && rawValue.length === 0)) {
      return '—';
    }

    const fieldType = customFieldDefinition?.type || field?.type;
    const parsedDate = new Date(rawValue);
    const isValidDate = !Number.isNaN(parsedDate.getTime());
    if (
      (fieldType === 'date' || fieldType === 'datetime' || fieldType === 'datetime-local') &&
      isValidDate
    ) {
      return <IntlDate disableSeconds withTime={fieldType !== 'date'} date={parsedDate} />;
    }

    if (customFieldDefinition?.options?.length) {
      const rawValues = Array.isArray(rawValue) ? rawValue : [rawValue];
      const resolvedValues = rawValues
        .map(
          value =>
            customFieldDefinition.options.find(option => option.value === value)?.key || value
        )
        .filter(value => value != null && value !== '');

      if (!resolvedValues.length) {
        return '—';
      }

      return resolvedValues.join(', ');
    }

    if (typeof rawValue === 'object') {
      return JSON.stringify(rawValue, null, 2);
    }

    return String(rawValue);
  };

  if (!customFieldValues.length) {
    return <div className='tooling-stock-card-new__custom-fields'>{emptyMessage}</div>;
  }

  return (
    <div className='tooling-stock-card-new__custom-fields'>
      {customFieldValues.map((field, idx) => {
        const customFieldDefinition = customFieldsByUri[field?.custom_field];
        const label =
          customFieldDefinition?.field_name ||
          field?.field_name ||
          field?.field_id ||
          getUuid(field?.custom_field) ||
          field?.custom_field;
        return (
          <div
            key={field?.custom_field || field?.field_id || `tool-custom-field-${idx}`}
            className='tooling-stock-card-new__custom-field'
          >
            <div className='tooling-stock-card-new__custom-field-label'>
              {label || 'Custom Field'}
            </div>
            <div className='tooling-stock-card-new__custom-field-value'>
              {renderValue(field, customFieldDefinition)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

ToolingStockCustomFields.propTypes = {
  customFieldValues: PropTypes.arrayOf(
    /* eslint-disable camelcase */
    PropTypes.shape({
      custom_field: PropTypes.string,
      field_id: PropTypes.string,
      field_name: PropTypes.string,
      type: PropTypes.string,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.shape({}),
      ]),
    })
    /* eslint-enable camelcase */
  ),
  customFieldsByUri: PropTypes.shape({}),
  emptyMessage: PropTypes.string,
};

ToolingStockCustomFields.defaultProps = {
  customFieldValues: [],
  customFieldsByUri: {},
  emptyMessage: 'No custom tool data available',
};

export default ToolingStockCustomFields;
